import { geometry } from 'app/contracts/Geometry';
import { particles } from 'app/contracts/Particles';
import { LookupType } from 'app/enum/Particles';

export class CircleLookup implements particles.ParticleLookup {
	private _path: Array<particles.ParticleLookupProps> = [];
	private _x: number;
	private _y: number;
	private _distance: number;
	private _i: number;

	constructor() {
		let steps: number = 360;
		for (var i = 0; i < steps; i++) {
			//Make scale / alpha at lowest on 180deg:
			let scaleAlphaValue = Math.abs(i - steps / 2) / (steps / 2);
			this._path.push({
				x: 1 * Math.cos((2 * Math.PI * i) / steps),
				y: 1 * Math.sin((2 * Math.PI * i) / steps),
				scale: scaleAlphaValue,
				alpha: scaleAlphaValue,
				rotation: i
			});
		}
	}

	public getClosestPoint(
		center: geometry.Vector2,
		size: geometry.Size,
		position: geometry.Vector2,
		maxDistance: number
	): number {
		let point: number = -1;
		let distance: number = 100000;

		for (this._i = 0; this._i < this._path.length; this._i++) {
			this._x = center.x + this._path[this._i].x * size.w;
			this._y = center.y + this._path[this._i].y * size.h;
			this._distance = Math.hypot(this._x - position.x, this._y - position.y);
			if (this._distance < maxDistance && this._distance < distance) {
				distance = this._distance;
				point = this._i;
			}
		}

		return point;
	}

	public get type(): LookupType {
		return LookupType.CIRCLE;
	}

	public get total(): number {
		return this._path.length;
	}

	public get table(): Array<particles.ParticleLookupProps> {
		return this._path;
	}

	public get(index: number): particles.ParticleLookupProps {
		return this._path[index];
	}
}
